const allowedPaths = [
  'more-scratch',
  'further-scratch',
  'microbit-intro',
  'python-intro',
]

const labels = {
  'scratch-intro': 'More Scratch slice',
  'further-scratch': 'Further Scratch slice',
  'python-intro': 'Python Intro slice',
  'microbit-intro': 'Microbit Intro slice',
}

export const signposting = (pathwaySlug) => {
  if (!allowedPaths.includes(pathwaySlug)) return
  return {
    gtmLabel: labels[pathwaySlug],
  }
}

export default signposting
